import React, { Component } from 'react'
import Heading from "../Reuseable/Heading"
import Img from 'gatsby-image'
export default class Productcart extends Component {
    constructor(props) {
        super(props)
        this.state = {
            products:props.products.edges,
            myproducts:props.products.edges,

        }
    }
    render() {
        //console.log(this.state.products)
        return (
            <section className="py-5">
                <div className="container">
                    <Heading title="Products"/>
                    <div className="row">

                        {this.state.myproducts.map(({node})=>{

                            return(
                                <div
                                key={node.id}
                                className="col-11 col-md-6 d-flex mx-auto my-3 px-3 "
                                >
                                <div className="card py-3 bg-white">
                                
                                <Img  fixed={node.image.fixed}/>
                                <div className="card-body">
                                <div className="flex-grow-1 ">
                                    <div className="d-flex justify-content-between">
                                        <h6 className="card-title">{node.title}</h6>
                                        
                                        <h4 className="mb-0 text-success ">₹ {node.price}</h4>


                                    </div>
                                    
                                    
                                    <p className="card-text text-muted">{node.description.description}</p>
                                        
                                    
                                    
                                    
                                </div>

                                </div>
                                <button data-item-id={node.id}
                                data-item-name={node.title}
                                data-item-price={node.price}
                                
                                data-item-url="https://svayuktyatheorganics.netlify.app"
                                data-item-image={node.image.fixed.src}
                                
                                className="btn btn-warning snipcart-add-item py-3 px-3">Buy Now</button>
                                </div>
                                </div>
                            )

                        })

                        }

                    </div>
                </div>
            
            </section>
        )
    }
}
